import React from "react";
import { Link } from "react-router-dom";
import { posts } from "./caseStudyData";

export default function CaseStudiesPage() {
  return (
    <main className="blog-page">
      <section className="blog-hero page-shell">
        <p className="eyebrow">CASE STUDIES</p>
        <h1>One platform. <em>Three kinds of business.</em></h1>
        <p>A walkthrough for each segment Nori is built for. All three use the same plans.</p>
        <p className="caveat blog-note">Concept case studies. They describe how Nori could work, not customer results.</p>
      </section>
      <section className="page-shell blog-list">
        {posts.map((post) => (
          <article className="blog-card" key={post.slug}>
            <Link className="blog-card-image" to={`/case-studies/${post.slug}`} aria-hidden="true" tabIndex="-1">
              <img src={post.image} alt="" loading="lazy" />
            </Link>
            <div className="blog-card-copy">
              <p className="blog-meta"><strong>{post.segment}</strong> · {post.date} · {post.readTime}</p>
              <h2><Link to={`/case-studies/${post.slug}`}>{post.title}</Link></h2>
              <p>{post.dek}</p>
              <Link className="text-link" to={`/case-studies/${post.slug}`}>Read the case study</Link>
            </div>
          </article>
        ))}
      </section>
    </main>
  );
}
